import React, { useState, useRef, useEffect } from "react";
import { reminderTimeDropdownOptions, validateDateWithWorkingHoursTimeZone } from "../../../../utils";
import Tippy from "@tippyjs/react";
import { getDateTimeWithFormat } from "../../../../utils";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import {
  Collaborator,
  Customer,
} from "../../../../constant/AuthenticationConstant";
import moment from "moment";
import { useSelector } from "react-redux";
import { useDrag, useDrop } from "react-dnd";
import update from "immutability-helper";

function DragAndDropComponent({
  assignmentFormik,
  arrayHelpersToDo,
  index,
  i,
  todoOptions,
  element,
  customerAndCollaboratorOptions,
  teamsOptions,
  usersOptions,
  workingHours
}) {
  const [hoverData, setHoverData] = useState([]);
  const [draggingState, setDraggingState] = useState();
  const [assignmentActivityList, setAssignmentActivityList] = useState([]);

  // Ref
  const dropRef = useRef(null);
  const dragRef = useRef(null);

  //Redux
  const { department_wise_user } = useSelector((state) => state.user);

  const getStatusStyles = (status) => {
    switch (status) {
      case "completed":
      case "completed with delay":
        return {
          className:
            "w-4 h-4 border-3 rounded-full border-[--bg-color-500] bg-[--bg-color-500]",
          innerDiv: null,
          tooltipContent: "completed",
        };
      case "pending":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500]",
          innerDiv: null,
        };
      case "in progress":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[--bg-color-500] relative",
          innerDiv: (
            <div className="absolute top-0 left-0 w-1/2 h-full bg-[--bg-color-500] rounded-l-full border-0"></div>
          ),
        };
      case "overdue":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313]",
          innerDiv: null,
          tooltipContent: "overdue",
        };
      case "overdue-inprogress":
        return {
          className: "w-4 h-4 border-3 rounded-full border-[#D31313] relative",
          innerDiv: (
            <div className="absolute top-0 left-0 w-1/2 h-full rounded-l-full border-0 bg-[#D31313]"></div>
          ),
          tooltipContent: "overdue-inprogress",
        };
      default:
        return {
          className: "w-4 h-4 border-3 rounded-full border-grey-500",
          innerDiv: null,
        };
    }
  };

  const renderStatus = (status) => {
    const { className, innerDiv, tooltipContent } = getStatusStyles(status);

    return status ? (
      <Tippy content={tooltipContent ?? status}>
        <div className={className}>{innerDiv}</div>
      </Tippy>
    ) : (
      <div className={className}>{innerDiv}</div>
    );
  };

  const show_assigned_team_or_users = (index, i) => {
    if (
      assignmentFormik?.values?.workflows[index]?.assignments[i]?.userSelect
    ) {
      return assignmentFormik?.values?.workflows[index]?.assignments[i]
        ?.userSelect?.label;
    } else if (
      assignmentFormik?.values?.workflows[index]?.assignments[i]
        ?.departmentSelect
    ) {
      return assignmentFormik?.values?.workflows[index]?.assignments[i]
        ?.departmentSelect?.label;
    } else {
      return "@ Team / User";
    }
  };

  const setReminderTime = (value, index, i) => {
    const reminderDateTime = moment(
      assignmentFormik.values.workflows[index].assignments[i].estimated_time
    )
      .subtract(value, "hours")
      .format("YYYY-MM-DD HH:mm");

    assignmentFormik.setFieldValue(
      `workflows[${index}].assignments[${i}].reminder_time`,
      reminderDateTime
    );
  };

  const getUsersOptions = (selectedTeams) => {
    if (selectedTeams) {
      if (
        selectedTeams.value === Collaborator ||
        selectedTeams.value === Customer
      ) {
        return customerAndCollaboratorOptions.filter(
          (item) => item.type === selectedTeams?.value
        );
      } else {
        const filteredData = usersOptions.filter((data) => {
          const user = department_wise_user.find(
            (user) => user?.id === data?.value
          );

          return user?.departments.some((item) => {
            return item?.id ? item?.id === selectedTeams?.value : false;
          });
        });
        return filteredData;
      }
    }
    return [];
  };

  const moveRow = (dragIndex, hoverIndex) => {
    console.log("moveRow is called", { dragIndex, hoverIndex });
    const dragRecord =
      assignmentFormik.values.workflows[index].assignments[dragIndex];

    setAssignmentActivityList(
      update(assignmentFormik.values.workflows[index].assignments, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRecord],
        ],
      })
    );

    setDraggingState(dragIndex);
  };

  // Handle Dragging Item
  const [{ isDragging }, drag, preview] = useDrag({
    type: "item",
    item: { i },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Handle Dropped Item
  const [, drop] = useDrop({
    accept: "item",
    hover(item, monitor) {
      if (!dropRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = i;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dropRef.current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveRow(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  preview(drop(dropRef));
  drag(dragRef);

  useEffect(() => {
    if (draggingState) {
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments`,
        assignmentActivityList
      );
    }
  }, [draggingState]);

  const linkLoopActivityName = (link_todo_id) => {
    const todoName = todoOptions.find((item) => item.value === link_todo_id);
    return todoName ? todoName.label : "";
  };

  const addEta = (date, index, i, previous_date, flag = false) => {
    const configurationSettingMappingData =
      assignmentFormik.values.workflows[index].assignments;

    if (date) {

      if(!flag){
        if(workingHours &&workingHours?.is_working_hours){
          const todoFind = configurationSettingMappingData.find(item => item.activity_id === assignmentFormik.values.workflows[index].assignments[i].activity_id);
          if(todoFind && (todoFind.dept_timzone || todoFind.user_timzone)){
            const timezone = todoFind?.user_timzone ? todoFind.user_timzone : todoFind.dept_timzone;
            if(timezone){
              const calculated_date = validateDateWithWorkingHoursTimeZone(timezone, workingHours, previous_date, date);
              if(calculated_date !== null) {
                date = calculated_date;
              }
            }
          }
        }
      }


      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].estimated_time`,
        new Date(date).toISOString()
      );

      if (
        assignmentFormik.values.workflows[index].assignments[i].reminder_time &&
        moment(date).isBefore(
          assignmentFormik.values.workflows[index].assignments[i].reminder_time
        )
      ) {
        assignmentFormik.setFieldValue(
          `workflows[${index}].assignments[${i}].reminder_time`,
          null
        );
        assignmentFormik.setFieldValue(
          `workflows[${index}].assignments[${i}].reminderTimeDropdownVal`,
          ""
        );
      }
    } else {
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].reminder_time`,
        null
      );
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].reminderTimeDropdownVal`,
        ""
      );
      assignmentFormik.setFieldValue(
        `workflows[${index}].assignments[${i}].estimated_time`,
        null
      );
    }

    for (
      let indexEst = 0;
      indexEst < configurationSettingMappingData.length;
      indexEst++
    ) {
      if (
        configurationSettingMappingData[indexEst].link_activity ===
        assignmentFormik.values.workflows[index].assignments[i].activity_id
      ) {
        const getIndex = assignmentFormik.values.workflows[
          index
        ].assignments.findIndex(
          (item) =>
            item.activity_id ===
            configurationSettingMappingData[indexEst].activity_id
        );

        const eta = moment(date)
          .add(configurationSettingMappingData[indexEst].duration, "hours")
          // .toDate();

        // assignmentFormik.setFieldValue(
        //   `workflows[${index}].assignments[${getIndex}].estimated_time`,
        //   new Date(eta).toISOString()
        // );

        addEta(eta, index, getIndex, date);
      }
    }
  };

  const currentDate = moment();
  // Creating function for default minimum date in estimater date.
  const getMinimumDate = (date) => {
    const isLessThanCurrentDate = moment(date).isBefore(currentDate);
    const isGreaterThanCurrentDate = moment(date).isAfter(currentDate);
    const equalToCurrentDate = moment(date).isSame(currentDate, "day");

    if (isLessThanCurrentDate) {
      return date;
    } else if (isGreaterThanCurrentDate) {
      return new Date();
    } else if (equalToCurrentDate) {
      return new Date();
    }
  };

  return (
    <div className="space-y-2" ref={dropRef}>
      <div className="w-full flex items-start space-x-2 relative">
        {/* To Do status */}
        <div className="w-[30px] space-y-2">
          <div className="w-full h-[30px] bg-[--bg-color-50] rounded-md flex items-center justify-center">
            {renderStatus(
              assignmentFormik.values.workflows[index].assignments[i]?.status
            )}
          </div>
          <div
            className={`${
              hoverData.some(
                (item) =>
                  item?.workflowIndex === index && item?.assignmentIndex === i
              )
                ? "block"
                : "hidden"
            } w-full rounded-md bg-[--bg-color-50] space-y-3 py-[18px]`}
          >
            <span
              className={`fas fa-asterisk text-sm pointer-events-none block text-center ${
                assignmentFormik.values.workflows[index].assignments[i]
                  ?.is_mandatory
                  ? "text-[--bg-color-500]"
                  : "text-[#9CA3AF]"
              } `}
            ></span>
            <Tippy
              content={linkLoopActivityName(
                assignmentFormik.values.workflows[index].assignments[i]
                  ?.link_activity
              )}
            >
              <span
                className={`fas fa-link text-sm  block text-center ${
                  assignmentFormik.values.workflows[index].assignments[i]
                    ?.link_activity
                    ? "text-[--bg-color-500]"
                    : "text-[#9CA3AF]"
                } `}
              ></span>
            </Tippy>
            <Tippy
              content={linkLoopActivityName(
                assignmentFormik.values.workflows[index].assignments[i]
                  ?.loop_activity
              )}
            >
              <span
                className={`fas fa-infinity text-sm block text-center ${
                  assignmentFormik.values.workflows[index].assignments[i]
                    ?.loop_activity
                    ? "text-[--bg-color-500]"
                    : "text-[#9CA3AF]"
                } `}
              ></span>
            </Tippy>
          </div>
          <div
            onClick={() => {
              if (
                hoverData.some(
                  (item) =>
                    item?.workflowIndex === index && item?.assignmentIndex === i
                )
              ) {
                setHoverData(
                  hoverData.filter(
                    (ele) =>
                      ele?.workflowIndex !== index && ele?.assignmentIndex !== i
                  )
                );
              } else {
                setHoverData([
                  ...hoverData,
                  {
                    workflowIndex: index,
                    assignmentIndex: i,
                  },
                ]);
              }
            }}
            className="w-full h-[30px] bg-[--bg-color-50] rounded-md flex items-center justify-center cursor-pointer"
          >
            <span
              className={`fa-solid ${
                hoverData.some(
                  (item) =>
                    item?.workflowIndex === index && item?.assignmentIndex === i
                )
                  ? "fa-chevron-up"
                  : "fa-chevron-down"
              } text-sm`}
            ></span>
          </div>
        </div>

        {/* To Do Assignment form */}
        {/* Default Div */}
        <div
          className={`${
            hoverData.some(
              (item) =>
                item?.workflowIndex === index && item?.assignmentIndex === i
            )
              ? "hidden"
              : "block"
          } rounded-md bg-[--bg-color-50] grow w-full p-2 flex items-center space-x-2`}
        >
          <div className="w-full space-y-3">
            <h4 className="text-sm font-semibold text-[#535860] leading-[100%] tracking-tight">
              {assignmentFormik.values.workflows[index].assignments[i]
                ?.activity_id
                ? todoOptions.find(
                    (todoItem) =>
                      todoItem.value ===
                      assignmentFormik.values?.workflows[index]?.assignments[i]
                        ?.activity_id
                  )?.label
                : "To Do Name"}
            </h4>
            <div className="flex justify-between items-center">
              <p className="text-[13px] font-semibold text-[--bg-color-500] leading-[100%] tracking-tight">
                {show_assigned_team_or_users(index, i)}
              </p>
              <p className="text-xs font-normal text-[#737373] leading-[100%] tracking-tight">
                {assignmentFormik.values?.workflows[index]?.assignments[i]
                  ?.estimated_time
                  ? getDateTimeWithFormat(
                      assignmentFormik.values?.workflows[index]?.assignments[i]
                        ?.estimated_time
                    )
                  : "Estimated End Date"}
              </p>
            </div>
          </div>
          {/* <div>
            <span
              ref={dragRef2}
              onMouseLeave={(e) => {
                setDraggingState(null);
              }}
              className="fa-regular fa-bars text-[#9CA3AF] text-sm cursor-pointer"
            ></span>
          </div> */}
        </div>
        {/* Div to show when hover */}
        <div
          className={`${
            hoverData.some(
              (item) =>
                item?.workflowIndex === index && item?.assignmentIndex === i
            )
              ? "block"
              : "hidden"
          } grow w-full rounded-md bg-[--bg-color-50] relative p-2 space-y-3.5`}
        >
          {/* To Do Dropdown and Remove btn */}
          <div className="w-full flex items-center space-x-2">
            <Select
              className="basic-single text-sm unresetText !px-0 grow"
              styles={{
                control: (provided) => ({
                  ...provided,
                  backgroundColor: "--bg-color-50",
                  borderColor: "#D9D9D9",
                  borderRadius: 0,
                  paddingLeft: 0,
                  paddingRight: 0,
                  color: "#535860",
                  fontSize: "14px",
                  fontWeight: 600,
                  ":focus": {
                    borderLeft: 0,
                    borderRight: 0,
                    borderTop: 0,
                    outline: 0,
                  },
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                  padding: 0,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9297A2",
                  fontSize: "14px",
                  fontWeight: 600,
                  paddingLeft: 0,
                  paddingRight: 0,
                }),
              }}
              classNames={{
                control: (style) => {
                  return `!border-t-0 !border-l-0 !border-r-0 !border-b-2 !px-0`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm !px-0";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              onChange={(todo) => {
                assignmentFormik.setFieldValue(
                  `workflows[${index}].assignments[${i}].activity_id`,
                  todo?.value
                );
              }}
              value={
                todoOptions.find(
                  (item) =>
                    item?.value ===
                    assignmentFormik?.values?.workflows[index]?.assignments[i]
                      ?.activity_id
                ) || ""
              }
              options={todoOptions}
              placeholder="Select To Do"
              menuPlacement="auto"
            />
            <h2
              className="text-rose-500 font-semibold text-[10px] tracking-tight cursor-pointer"
              onClick={() => arrayHelpersToDo.remove(i)}
            >
              Remove
            </h2>
          </div>

          {/* Assignment Form Fields */}
          <div className="flex items-center space-x-2">
            <div className="grid grid-cols-2 gap-2 grow">
              <div>
                <label
                  className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                >
                  Assigned Team
                </label>
                <Select
                  className="basic-single text-sm unresetText"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: "white",
                      borderColor: "lightgray",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: "#9297A2",
                      fontSize: "14px",
                    }),
                  }}
                  classNames={{
                    control: (style) => {
                      return `!border !shadow-sm ${
                        style.isFocused
                          ? "!border-[--bg-color-300]/50"
                          : "!border-slate-200 hover:!border-gray-300"
                      }`;
                    },
                    container: (style) => {
                      return "!h-[37.5px] !font-inter !text-sm";
                    },
                    menuList: (style) => {
                      return `!max-h-[200px]`;
                    },
                  }}
                  onChange={(event) => {
                    if (
                      event.value === Collaborator ||
                      event.value === Customer
                    ) {
                      assignmentFormik.setFieldValue(
                        `workflows[${index}].assignments[${i}].departmentSelect`,
                        event
                      );
                    } else {
                      assignmentFormik.setFieldValue(
                        `workflows[${index}].assignments[${i}].department_id`,
                        event.value
                      );
                      assignmentFormik.setFieldValue(
                        `workflows[${index}].assignments[${i}].departmentSelect`,
                        event
                      );
                    }
                    assignmentFormik.setFieldValue(
                      `workflows[${index}].assignments[${i}].userSelect`,
                      ""
                    );
                    assignmentFormik.setFieldValue(
                      `workflows[${index}].assignments[${i}].user_id`,
                      null
                    );
                    assignmentFormik.setFieldValue(
                      `workflows[${index}].assignments[${i}].collaborator_id`,
                      null
                    );
                  }}
                  value={
                    assignmentFormik.values?.workflows[index]?.assignments[i]
                      ?.departmentSelect
                  }
                  options={[
                    {
                      label: "Collaborator",
                      value: Collaborator,
                    },
                    {
                      label: "Customer",
                      value: Customer,
                    },
                    {
                      label: "Internal Teams",
                      options: teamsOptions,
                    },
                  ]}
                  placeholder="Select Team"
                  menuPlacement="auto"
                />
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                >
                  Assigned User
                </label>
                <Select
                  className="basic-single text-sm unresetText"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: "white",
                      borderColor: "lightgray",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: "#9297A2",
                      fontSize: "14px",
                    }),
                  }}
                  classNames={{
                    control: (style) => {
                      return `!border !shadow-sm ${
                        style.isFocused
                          ? "!border-[--bg-color-300]/50"
                          : "!border-slate-200 hover:!border-gray-300"
                      }`;
                    },
                    container: (style) => {
                      return "!h-[37.5px] !font-inter !text-sm";
                    },
                    menuList: (style) => {
                      return `!max-h-[200px]`;
                    },
                  }}
                  onChange={(userEvent) => {
                    assignmentFormik.setFieldValue(
                      `workflows[${index}].assignments[${i}].userSelect`,
                      userEvent
                    );
                    if (
                      assignmentFormik.values?.workflows[index]?.assignments[i]
                        ?.departmentSelect?.value === Collaborator ||
                      assignmentFormik.values?.workflows[index]?.assignments[i]
                        ?.departmentSelect?.value === Customer
                    ) {
                      assignmentFormik.setFieldValue(
                        `workflows[${index}].assignments[${i}].collaborator_id`,
                        userEvent.value
                      );
                    } else {
                      assignmentFormik.setFieldValue(
                        `workflows[${index}].assignments[${i}].user_id`,
                        userEvent.value
                      );
                    }
                  }}
                  value={
                    assignmentFormik.values?.workflows[index]?.assignments[i]
                      ?.userSelect
                  }
                  options={getUsersOptions(
                    assignmentFormik.values?.workflows[index]?.assignments[i]
                      ?.departmentSelect
                  )}
                  placeholder="Select User"
                  menuPlacement="auto"
                />
              </div>
              <div>
                <div className="relative">
                  <label
                    className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                    htmlFor="card-city"
                  >
                    End Date
                  </label>
                  <Flatpickr
                    data-enable-time
                    options={{
                      altFormat: "j M, Y H:i",
                      dateFormat: "Y-m-d H:i",
                      time_24hr: true,
                      disableMobile: true,
                      enableTime: true,
                      altInput: true,
                      minDate: !assignmentFormik.values.workflows[index].assignments[i]
                      ?.estimated_time ? new Date() : getMinimumDate(
                        assignmentFormik.values.workflows[index].assignments[i].estimated_time
                      ),
                    }}
                    value={
                      assignmentFormik?.values?.workflows[index]?.assignments[i]
                        ?.estimated_time
                    }
                    onChange={(e) => {
                      assignmentFormik.setFieldValue(
                        `workflows[${index}].assignments[${i}].estimated_time`,
                        new Date(e[0]).toISOString()
                      );
                      addEta(e[0], index, i, assignmentFormik?.values?.workflows[index]?.assignments[i]?.estimated_time, true);
                    }}
                    render={({ defaultValue }, ref) => {
                      return (
                        <div className="w-full">
                          <input
                            title="Component Placeholder"
                            className="form-input w-[100%] truncate disabled:border-slate-200"
                            defaultValue={defaultValue}
                            ref={ref}
                            placeholder="Select End Date"
                          />
                          <div className="absolute inset-0 left-auto !top-8 opacity-100 group">
                            <span className="text-sm text-slate-500 font-medium px-3 ">
                              <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                            </span>
                          </div>
                        </div>
                      );
                    }}
                  />
                </div>
              </div>
              <div>
                <label
                  className={`block text-sm font-medium mb-1 leading-3 tracking-tight`}
                >
                  Reminder
                </label>
                <Select
                  className="basic-single text-sm unresetText"
                  isDisabled={
                    !assignmentFormik?.values?.workflows[index]?.assignments[i]
                      ?.estimated_time
                  }
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: "lightgray",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: "#9297A2",
                      fontSize: "14px",
                    }),
                  }}
                  classNames={{
                    control: (style) => {
                      return `!border !shadow-sm ${
                        style.isFocused
                          ? "!border-[--bg-color-300]/50"
                          : "!border-slate-200 hover:!border-gray-300"
                      }`;
                    },
                    container: (style) => {
                      return "!h-[37.5px] !font-inter !text-sm";
                    },
                    menuList: (style) => {
                      return `!max-h-[200px]`;
                    },
                  }}
                  onChange={(reminderEvent) => {
                    assignmentFormik.setFieldValue(
                      `workflows[${index}].assignments[${i}].reminderTimeDropdownVal`,
                      reminderEvent
                    );
                    setReminderTime(reminderEvent.value, index, i);
                  }}
                  value={
                    assignmentFormik?.values?.workflows[index]?.assignments[i]
                      ?.reminderTimeDropdownVal
                  }
                  options={reminderTimeDropdownOptions}
                  placeholder="Select Reminder"
                  menuPlacement="auto"
                />
              </div>
            </div>
            <div className="invisible">
              <span
                ref={dragRef}
                onMouseLeave={(e) => {
                  setDraggingState(null);
                }}
                className="fa-regular fa-bars text-[#9CA3AF] text-sm cursor-pointer"
              ></span>
            </div>
          </div>
        </div>

        {/* Drag icon */}
        <div
          className={`absolute right-2 ${
            hoverData.some(
              (item) =>
                item?.workflowIndex === index && item?.assignmentIndex === i
            ) ? "top-1/2" : "top-2"
          }`}
        >
          <span
            ref={dragRef}
            onMouseLeave={(e) => {
              setDraggingState(null);
            }}
            className="fa-regular fa-bars text-[#9CA3AF] text-sm cursor-pointer"
          ></span>
        </div>
      </div>
      {/* Add To Do Button */}
      <div
        className={`w-full ${
          hoverData.some(
            (item) =>
              item?.workflowIndex === index && item?.assignmentIndex === i
          )
            ? "block"
            : "hidden"
        }`}
      >
        <button
          className="w-full btn bg-white border-slate-200 hover:border-slate-300 text-[--bg-color-500] cursor-pointer font-semibold"
          onClick={(event) => {
            event.preventDefault();
            arrayHelpersToDo.insert(i + 1, {
              // activity_assignment_mapping_id:
              //   "", // used while updating
              activity_id: null,
              department_id: null,
              user_id: null,
              sequence: i + 2,
              is_mandatory: false,
              link_activity: null,
              loop_activity: null,
              duration: 0,
              collaborator_id: null,
              estimated_time: null,
              reminder_time: null,
              departmentSelect: "",
              userSelect: "",
              reminderTimeDropdownVal: "",
              status: "pending",
            });
          }}
        >
          + Add To Do
        </button>
      </div>
    </div>
  );
}

export default DragAndDropComponent;
